import { useEffect, useState } from 'react'
import { RiArrowDownSLine } from 'react-icons/ri';

const SelectAddress = (props) => {
    const {
        showOptionAddress,
        setShowOptionAddress,
        toggleDropdownAddress,
        addresses,
        handleAddressSelection,
        selectedAddressId,
        orderData,
        handleChange
    } = props;

    const [inputValue, setInputValue] = useState('');

    useEffect(() => {
        if (selectedAddressId && addresses?.length) {
            const selected = addresses.find(item => item.id === selectedAddressId);
            if (selected) {
                setInputValue(selected.label);
            } else {
                setInputValue('');
            }
        }
    }, [selectedAddressId, addresses]);

    const handleInputChange = (e) => {
        const value = e.target.value;
        setInputValue(value);
        if (selectedAddressId) {
            console.log(selectedAddressId, "selectedAddressId")
            handleAddressSelection({ id: selectedAddressId });
        }
        handleChange({
            target: {
                name: 'destination_name',
                value: value
            }
        });
    };

    const handleSelectAddress = (option) => {
        if (selectedAddressId === option.id) {
            handleAddressSelection(option);
            setInputValue('');
        } else {
            handleAddressSelection(option);
            setInputValue(option.label);
        }
    };

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (!event.target.closest(".dropdown-container")) {
                setShowOptionAddress({ destination_address: false });
            }
        };
        document.addEventListener("click", handleOutsideClick);
        return () => {
            document.removeEventListener("click", handleOutsideClick);
        };
    }, []);

    return (
        <div className="flex flex-col md:w-[100%] lg:w-[48%] w-full gap-3">
            <label className="text-sm font-semibold poppins-medium text-[#6B6B6B]">
                Nome
            </label>
            <div className="flex flex-col w-full space-y-3 dropdown-container select_addr_dropdown">
                <div className="relative group w-full">
                    <div className="flex items-center relative">
                        <input
                            type="text"
                            name="destination_name"
                            placeholder="Nome"
                            className="input_name_field poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef] w-full transition-all duration-200 ease-in-out"
                            value={inputValue}
                            onChange={handleInputChange}
                        />
                        <button
                            className="absolute right-0 mr-2"
                            onClick={() => toggleDropdownAddress("destination_address")}
                        >
                            <RiArrowDownSLine
                                className={`transform transition-transform duration-200 ${showOptionAddress.destination_address ? "rotate-180" : ""
                                    }`}
                                size={"24px"}
                                color="#9f414f"
                            />
                        </button>
                    </div>
                    <div
                        className={` ${showOptionAddress.destination_address ? "opacity-100 z-50 visible " : "opacity-0 z-20 overflow-hidden invisible"
                            } addr_dropdown bg-[#FFFFFF] h-[120px]
                                                    border-[#d5d6d9]  absolute pt-[9px] rounded-t-none border-t-0 p-2 px-4 right-0 mt-0 rounded-[21px] shadow-lg text-[#DB7685] space-y-1 w-full border transition-all duration-300 ease-in-out`}
                    >
                        <div className="max-h-[100px] overflow-y-auto btn-all-yscroll">
                            {addresses && addresses.length > 0 ?
                                addresses.map((option) => (
                                    <div className="flex gap-[15px]" key={option.id}>
                                        <label
                                            className="px-0 py-2 cursor-pointer flex justify-between flex-row gap-[15px] filter_list_btn"
                                        >
                                            <input
                                                type="checkbox"
                                                className="outline-none cursor-pointer"
                                                checked={selectedAddressId === option.id}
                                                // onChange={() => {
                                                //     handleAddressSelection(option);
                                                //     setInputValue(option.label);
                                                // }}
                                                onChange={() => handleSelectAddress(option)}
                                            />
                                        </label>
                                        <span className="text-[#6B6B6B] rounded-md flex items-center gap-3 poppins-regular text-sm">
                                            {option.label}
                                        </span>
                                    </div>
                                )) : (
                                    <div className="flex items-center justify-center p-5">
                                        <span className="text-xs text-[#8B8B8B] rounded-md flex items-center poppins-regular">
                                            No Options
                                        </span>
                                    </div>
                                )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SelectAddress;